import React, { useState } from "react";
import { Row, Col, FormGroup, Label, Input, Button, Card, CardBody } from "reactstrap";
// Check your paths - usually ../../request or ../../api
import axiosInstance from "../../request"; 
import { URL } from "../../api";           

const MandateRegistrationReporting = () => {
  const [customerId, setCustomerId] = useState("");
  const [loanId, setLoanId] = useState(""); 
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);

  const handleDownload = async () => {
    try {
      setLoading(true);

      const params = {
        ...(customerId && { customerId }),
        ...(loanId && { loanId }),
        ...(fromDate && { fromDate }),
        ...(toDate && { toDate })
      };

      // API call to the backend endpoint we created
      const response = await axiosInstance.get(URL.REGISTRATION_EXCEL, {
        params,
        responseType: "blob", 
      });

      // Handle the file download
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      
      const fileName = `Mandate_Registration_${new Date().toISOString().split('T')[0]}.csv`;
      link.setAttribute("download", fileName);
      
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error("Export Error:", error);
      alert("Report download failed. Please verify filters or backend status.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="shadow-sm border-0 mt-3">
      <CardBody>
        <h5 className="text-muted mb-4">Mandate Registration Filters</h5>
        <Row className="align-items-end">
          <Col md="2">
            <FormGroup>
              <Label className="small fw-bold">Customer ID</Label>
              <Input
                type="number"
                placeholder="CID"
                value={customerId}
                onChange={(e) => setCustomerId(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="2">
            <FormGroup>
              <Label className="small fw-bold">Loan ID</Label>
              <Input
                type="number"
                placeholder="Loan ID"
                value={loanId}
                onChange={(e) => setLoanId(e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Label className="small fw-bold">From Date</Label>
              <Input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
            </FormGroup>
          </Col>
          <Col md="3">
            <FormGroup>
              <Label className="small fw-bold">To Date</Label>
              <Input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
            </FormGroup>
          </Col>
          <Col md="2" className="mb-3">
            <Button color="success" block onClick={handleDownload} disabled={loading}>
              {loading ? "Exporting..." : "Excel"}
            </Button>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default MandateRegistrationReporting;